(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.PawmatixAssessmentShuffle = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function shuffledCopy(items, random) {
    var copy = items.map(function (item) {
      return Object.assign({}, item);
    });
    for (var index = copy.length - 1; index > 0; index -= 1) {
      var target = Math.floor(random() * (index + 1));
      var current = copy[index];
      copy[index] = copy[target];
      copy[target] = current;
    }
    return copy;
  }

  function shuffleAttempt(questions, random) {
    var sourceRandom = typeof random === 'function' ? random : Math.random;
    var cloned = questions.map(function (question) {
      return Object.assign({}, question, {
        options: shuffledCopy(question.options || [], sourceRandom),
      });
    });
    return shuffledCopy(cloned, sourceRandom);
  }

  return { shuffleAttempt: shuffleAttempt };
});
